<template>
  <b-container fluid class="p-0 h-100" :class="accentClass">
    <b-row class="no-gutters min-h-100 flex-nowrap">
      <b-col cols="auto" class="full-height-sidebar">
        <side-nav />
      </b-col>
      <b-col class="main-content-col">
        <b-row class="user-topbar no-gutters border border-top-0 border-left-0 border-right-0">
          <b-col class="my-auto">
            <div class="float-left ml-5 d-md-block">
              <the-breadcrumbs />
            </div>
          </b-col>

          <b-col sm="auto" class="bg-light border border-top-0 border-bottom-0 border-right-0">
            <b-dropdown variant="light" class="user-dropdown" menu-class="p-0 user-dropdown-menu">
              <template slot="button-content">
                Hello, <b>{{ firstName }}</b>
              </template>
            <b-dropdown-item :to="{ name: 'AccountDetails', params: { uid: user.id } }">Account</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item href="/logout" class="text-danger">Log Out</b-dropdown-item>
          </b-dropdown>
          </b-col>
        </b-row>

        <b-container fluid class="m-0 mb-5" :class="{ 'p-4': !noPadding, 'p-0': noPadding }">
          <router-view class="d-block animated">
            <!-- content yo -->
          </router-view>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<style>
@import url('vue2-animate/dist/vue2-animate.min.css');

.min-h-100 {
  min-height: 100%;
}
.main-content-col {
  min-width: 0;
}
.full-height-sidebar {
  overflow-y: hidden;
}
a:focus {
  outline: none !important;
}
.dropdown-divider {
  margin: 0px !important;
}
.dropdown-menu {
  padding-top: 0px;
  padding-bottom: 0px;
}
.user-dropdown .dropdown-item {
  padding-top: 15px;
  padding-bottom: 15px;
}
.user-topbar {
  height: 60px;
}
.user-dropdown {
  display: flex;
  text-align: center;
  width: 200px;
  height: 100%;
}
.user-dropdown .dropdown-toggle::after {
  margin-left: 1em;
  content: "\e906";
  top: -10px;
  left: -15px;
  transform: scale(2);
  font-family: icomoon;
  border: none;
  vertical-align: baseline;
}
.user-dropdown .dropdown-toggle {
  width: 100%;
  border-radius: 0px;
  border: 0px;
}
.user-dropdown .dropdown-toggle:focus,
.user-dropdown .dropdown-toggle:hover,
.show>.dropdown-toggle {
  background-color: initial !important;
  border: 0px;
}
.user-dropdown .dropdown-menu {
  border-top: none;
  border-right: none;
  width: 202px !important;
  margin-left: -2px;
  text-align: center;
  border-radius: 0;
  transform: translate(0, 0) !important;
  left: 0;
  top: 100% !important;
}
</style>

<script>
  import SideNav from '@/components/SideNav'
  import TheBreadcrumbs from '@/components/TheBreadcrumbs'
  import { getCSSVariable, setCSSVariable } from '@/components/utils.js'

  import auth from '@/auth'

  export default {
    props: {
      noPadding: { required: false, default: false, type: Boolean }
    },
    created () {
      this.changeAccentColor()
    },
    methods: {
      /*
       * This is a function that changes the css vars in :root
       * so that the correct colors can be accessed.
       */
      changeAccentColor () {
        // change css primary color
        switch (this.accentClass) {
          case 'accent-admin':
            setCSSVariable('primary', getCSSVariable('admin'))
            setCSSVariable('light-primary', getCSSVariable('light-admin'))
            break
          case 'accent-publisher':
            setCSSVariable('primary', getCSSVariable('publisher'))
            setCSSVariable('light-primary', getCSSVariable('light-publisher'))
            break
          case 'accent-demand':
            setCSSVariable('primary', getCSSVariable('demand'))
            setCSSVariable('light-primary', getCSSVariable('light-demand'))
            break
            case 'accent-exchange':
                setCSSVariable('primary', getCSSVariable('exchange'))
                setCSSVariable('light-primary', getCSSVariable('light-exchange'))
                break
          default:
            setCSSVariable('primary', getCSSVariable('white'))
            setCSSVariable('light-primary', getCSSVariable('white'))
        }

        console.log('accent class is ' + this.accentClass)
      },
    },
    data () {
      return {
        user: auth.details(),
        items: [{
          text: 'Dashboard',
          href: '/dashboard'
        }]      }
    },
    computed: {
      isAdmin () {
        return auth.isAdmin()
      },
      accentClass () {
        let p = this.$route.path
        if(p.indexOf('/admin') !== -1) {
          return 'accent-admin'
        }
        if(p.indexOf('/publisher') !== -1) {
          return 'accent-publisher'
        }
        if(p.indexOf('/demand') !== -1) {
          return 'accent-demand'
        }
        if(p.indexOf('/exchange') !== -1) {
          return 'accent-exchange'
        }
        console.log('Idk what accent to apply where are we')
        return '';
      },
      firstName () {
        let d = auth.details()
        if(!d) {
          return
        }
        let name = d.name
        let spaceIndex = name.indexOf(' ')
        if(spaceIndex === -1) {
          spaceIndex = name.length
        }
        return name.substr(0, spaceIndex)
      },
    },
    watch: {
      accentClass () {
        this.changeAccentColor()
      }
    },
    components: {
      SideNav,
      TheBreadcrumbs
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ContentPage.vue